import { render, staticRenderFns } from "./StudentLoginContainer.vue?vue&type=template&id=568121d8&scoped=true"
import script from "./StudentLoginContainer.vue?vue&type=script&lang=ts"
export * from "./StudentLoginContainer.vue?vue&type=script&lang=ts"
import style0 from "./StudentLoginContainer.vue?vue&type=style&index=0&id=568121d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568121d8",
  null
  
)

export default component.exports